// TODO: Section❓
import ScrollDirection from '../mixins/scroll-direction';
import cssClasses from '../helpers/cssClasses';
import { on } from '../helpers/utils';


/**
 * DOM selectors.
 */
const selectors = {
  navTrigger: '[js-mobile-nav="toggle"]',
  navHide: '[js-mobile-nav="hide"]',
  mobileNav: '[js-nav="mobile"]',
  siteHeader: '[js-site-header="true"]',
  siteHeaderOverlay: '[js-site-header="overlay"]',
  meganavTrigger: '[js-meganav="trigger"]',
  fixedContainer: '[js-site-header="fixed-container"]',

  megaTierTrigger: '[js-mega-tier="trigger"]',
  megaTierTarget: '[js-mega-tier="target"]',
};

export default () => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    navTrigger: document.querySelector(selectors.navTrigger),
    navHide: document.querySelector(selectors.navHide),
    mobileNav: document.querySelector(selectors.mobileNav),
    siteHeader: document.querySelector(selectors.siteHeader),
    siteHeaderOverlay: document.querySelector(selectors.siteHeaderOverlay),
    meganavTrigger: document.querySelectorAll(selectors.meganavTrigger),
    fixedContainer: document.querySelector(selectors.fixedContainer),
    megaTierTrigger: document.querySelectorAll(selectors.megaTierTrigger),
    megaTierTarget: document.querySelectorAll(selectors.megaTierTarget),
  };

  /**
   * Instantiate a collapsed header on scroll using scrollDirection helper.
   */
  function constructStickyNavigation() {
    // eslint-disable-next-line no-unused-vars
    const FixedNavigation = ScrollDirection({
      throttle: 50,
      start: 0,
    }).init();
  }

  /**
   * Set events Listeners.
   */
  function setEventListeners() {
    nodeSelectors.navTrigger.addEventListener('click', toggleActiveState);

    if (nodeSelectors.navHide !== null) {
      nodeSelectors.navHide.addEventListener('click', removeActiveState);
    }

    nodeSelectors.siteHeaderOverlay.addEventListener(
      'click',
      removeActiveState
    );

    document.documentElement.addEventListener('keydown', handleKeydown);

    nodeSelectors.megaTierTrigger.forEach((item) => {
      on('mouseover', item, (event) => showMegaTier(event, item));
    });
  }

  function showMegaTier(event, item) {
    const tier = item.dataset.megaTier;
    const target = `[js-mega-tier-count="target-${tier}"]`
    const nodeTarget = document.querySelector(target);
    nodeSelectors.megaTierTarget.forEach((item) => {
      item.classList.remove(cssClasses.active)
    });

    nodeTarget.classList.add(cssClasses.active);

    Karmoon.EventBus.emit('ShowMega:open');
  }

  /**
   * Set Event Bus listeners
   * These are normal trigger from other JS events.
   */
  function setEvenBustListeners() {
    Karmoon.EventBus.listen('ScrollDirection:down', (position) => {
      enableFixedHeader(position);
    });

    Karmoon.EventBus.listen('ScrollDirection:up', (position) => {
      disableFixedHeader(position);
    });
  }

  function enableFixedHeader(position) {
    if (position > nodeSelectors.fixedContainer.offsetTop) {
      nodeSelectors.fixedContainer.classList.add(cssClasses.active);
    }
  }

  function disableFixedHeader(position) {
    if (position < nodeSelectors.fixedContainer.offsetTop) {
      nodeSelectors.fixedContainer.classList.remove(cssClasses.active);
    }
  }

  function toggleActiveState() {
    if (nodeSelectors.mobileNav.classList.contains(cssClasses.active)) {
      removeActiveState();
    } else {
      addActiveState();
    }
  }

  function handleKeydown(event) {
    if (event.keyCode === 27) {
      removeActiveState();
      return true;
    }
    return false;
  }

  function removeActiveState() {
    nodeSelectors.mobileNav.classList.remove(cssClasses.active);
    document.querySelector('body').style.overflowY = 'initial';
  }

  function addActiveState() {
    nodeSelectors.mobileNav.classList.add(cssClasses.active);
    document.querySelector('body').style.overflowY = 'hidden';
  }

  function setMeganavTop() {
    if (nodeSelectors.meganavTrigger === null) { return; }

    const siteHeaderHeight = nodeSelectors.siteHeader.offsetHeight;

    document.querySelectorAll('.meganav').forEach((item) => {
      item.style.top = `${siteHeaderHeight}px`;
    });
  }

  /**
   * Initialise component.
   */
  function init() {
    constructStickyNavigation();
    setMeganavTop();
    setEventListeners();
    setEvenBustListeners();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
    removeActiveState,
  });
};
